import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';
import { AccountingDepositDetailsEntity } from '../../../../../../api/types/accounting/accounting-deposit-details-entity';

export const getAccountingDepositsListOperation = async (
  offset: number,
  limit: number,
  setData: (data: AccountingDepositDetailsEntity[]) => void,
  setTotal: (total: number) => void,
  setLoading: (loading: boolean) => void,
) => {
  try {
    setLoading(true);

    const res = await appApi.getAccountingDepositsList(offset, limit);

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    setData(res.data.body.data ?? []);
    setTotal(res.data.body.total ?? 0);
    setLoading(false);
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
